export default __webpack_public_path__ + "static/media/map.e59da1cd.svg";